import { CreativeV5Type } from '../../../../apis/graphql/types';
import type { CreativeType } from '../../../../configs/creativeTypes';

export const SUPPORTED_CREATIVE_TYPES: CreativeType[] = [
  CreativeV5Type.VastVideo,
  CreativeV5Type.Video,
  CreativeV5Type.Slate,
];

/** Creative types within a group can be substituted when resolving line-item compatibility. */
export const INTERCHANGEABLE_CREATIVE_TYPE_GROUPS: CreativeType[][] = [[CreativeV5Type.Video, CreativeV5Type.Slate]];
